import { without } from 'lodash';
import { compose, withHandlers, withState } from 'recompose';

const withExpandedService = compose(
  withState(
    'expandedServices',
    'setExpandedServices',
    []
  ),
  withHandlers({
    toggleExpandedService: props => (serviceId) => {
      const { expandedServices, setExpandedServices } = props;
      setExpandedServices(
        expandedServices.includes(serviceId)
          ? without(expandedServices, serviceId)
          : [...expandedServices, serviceId]
      );
    },
  })
);

export default withExpandedService;
